interface IEqualityScope extends ng.IScope {
    otherModelValue: any;
}

export class compareTo {
    constructor() {
        let directive: ng.IDirective = {};
        directive.restrict = "A";
        directive.require = "ngModel";
        directive.scope = {
            otherModelValue: "=compareTo"
        };
        directive.link = (scope: ng.IScope, element: JQLite, attributes: ng.IAttributes, ngModel: ng.INgModelController) => {
            let $scope = scope as IEqualityScope;
            ngModel.$validators.compareTo = function (modelValue) {
                return modelValue === $scope.otherModelValue;
            };

            scope.$watch("otherModelValue", function () {
                ngModel.$validate();
            });
        }
        return directive;
    }
}